import Activation from './components/Activation';

export default Activation;
